import { defineComponent as j, ref as y, computed as s, onMounted as M, onUnmounted as Y, createElementBlock as f, createCommentVNode as o, openBlock as n, createBlock as x, createElementVNode as u, unref as b, Fragment as q, renderList as G, normalizeClass as w, toDisplayString as k, resolveDynamicComponent as T, normalizeStyle as H } from "vue";
import { RevButtonIcon as B } from "@ds/components/ButtonIcon";
import { usePositionedStyle as J } from "../../composables/usePositionedStyle.js";
import K from "../../icons/generated/IconArrowLeft.vue2.js";
import Q from "../../icons/generated/IconCross.vue2.js";
import { isEmpty as X } from "../../utils/isEmpty.js";
import { createObserver as Z } from "../../utils/resizeObserver.js";
import { tw as i } from "../../utils/tailwind.js";
const ee = {
  key: 1,
  class: "flex flex-1 list-none flex-nowrap"
}, te = ["aria-label"], ae = { class: "line-clamp-2 flex-1" }, le = { class: "line-clamp-2 flex flex-1 items-center justify-center" }, se = {
  "aria-hidden": "",
  class: "border-t-static-default-low absolute bottom-0 h-2 w-full border-t-2"
}, ne = ["max", "value"], pe = /* @__PURE__ */ j({
  name: "RevStepper",
  __name: "Stepper",
  props: {
    activeStep: {},
    hasBack: { type: Boolean },
    alternativeTextBack: {},
    hasClose: { type: Boolean },
    alternativeTextClose: {},
    steps: {},
    alternativeTextCompleted: {},
    alternativeTextCurrent: {}
  },
  emits: ["back", "close"],
  setup(l, { emit: _ }) {
    const t = l, S = _, v = y(null), m = y(null);
    let p;
    const a = s(
      () => t.steps.findIndex(({ name: e }) => e === t.activeStep)
    ), R = s(
      () => `Step ${+a.value + 1} of ${t.steps.length}`
    ), C = s(() => !X(t.steps)), L = s(() => {
      const e = a;
      return `${+e.value + 1}/${t.steps.length} ${t.steps[+e.value].label}`;
    }), I = s(() => +a.value + 1), h = s(() => m.value ? m.value < 768 ? !1 : m.value < 1200 ? t.steps.length <= 3 : t.steps.length <= 5 : !0);
    M(() => {
      C.value && (p = Z({
        $el: v.value,
        autoUnobserve: !1,
        callback: (c) => {
          const r = c[0];
          m.value = r.contentRect.width;
        }
      }), p && v.value !== null && p.observe(v.value));
    }), Y(() => {
      p?.disconnect();
    });
    const A = () => {
      S("back");
    }, D = () => {
      S("close");
    }, E = (e) => e.name === t.activeStep, N = (e) => e > a.value, z = (e) => e < +a.value ? t.alternativeTextCompleted : e === +a.value ? t.alternativeTextCurrent : "", O = (e, c) => [
      i`flex h-56 flex-1 items-center border-0 bg-transparent px-40 text-center`,
      E(e) ? i`body-1-bold` : i`body-1`,
      N(c) ? i`text-static-default-low` : i`text-static-default-hi`
    ], g = (e, c) => `${c + 1}. ${e.label}`, U = {
      left: "0",
      width: "0px"
    }, $ = y(), V = s(() => $?.value?.[a.value]), { style: F } = J({
      callback: (e) => ({
        left: "0",
        width: `${e.offsetLeft + e.offsetWidth}px`
      }),
      defaultStyle: U,
      elementRef: V
    }), P = s(() => h.value ? F.value : {
      left: 0,
      width: `${100 * (1 + a.value) / t.steps.length}%`
    }), W = s(() => [
      i`text-static-default-hi body-1 flex h-56 w-full items-center text-center`,
      (t.hasBack || t.hasClose) && i`px-40`
    ]);
    return (e, c) => C.value ? (n(), f("div", {
      key: 0,
      ref_key: "wrapper",
      ref: v,
      class: "relative flex items-center"
    }, [
      l.hasBack ? (n(), x(b(B), {
        key: 0,
        "alternative-text": l.alternativeTextBack,
        class: "absolute inset-y-0 left-0 mt-8",
        icon: b(K),
        variant: "secondary",
        onClick: A
      }, null, 8, ["alternative-text", "icon"])) : o("", !0),
      h.value ? (n(), f("ol", ee, [
        (n(!0), f(q, null, G(l.steps, (r, d) => (n(), f("li", {
          key: r.name,
          ref_for: !0,
          ref_key: "stepsRef",
          ref: $,
          "aria-label": `${z(d)} ${g(
            r,
            d
          )}`,
          class: w(O(r, d)),
          "data-test": "step.name"
        }, [
          u("span", ae, k(g(r, d)), 1),
          r.suffix ? (n(), x(T(r.suffix), { key: 0 })) : o("", !0)
        ], 10, te))), 128))
      ])) : o("", !0),
      h.value ? o("", !0) : (n(), f("div", {
        key: 2,
        class: w(W.value)
      }, [
        u("span", le, [
          u("span", null, k(L.value), 1),
          l.steps[a.value].suffix ? (n(), x(T(l.steps[a.value].suffix), { key: 0 })) : o("", !0)
        ])
      ], 2)),
      l.hasClose ? (n(), x(b(B), {
        key: 3,
        "alternative-text": l.alternativeTextClose,
        class: "absolute inset-y-0 right-0 mt-8",
        icon: b(Q),
        variant: "secondary",
        onClick: D
      }, null, 8, ["alternative-text", "icon"])) : o("", !0),
      u("div", se, [
        u("div", {
          class: "border-t-static-default-hi absolute -top-2 border-t-2 ease-in-out motion-safe:transition-all motion-safe:duration-200",
          style: H(P.value)
        }, null, 4)
      ]),
      u("progress", {
        class: "sr-only",
        max: l.steps.length,
        value: I.value
      }, k(R.value), 9, ne)
    ], 512)) : o("", !0);
  }
});
export {
  pe as default
};
